import(/* webpackMode: "eager" */ "/app/src/features/news/NewsBlogSection/NewsBlogSection.module.scss");
;
import(/* webpackMode: "eager" */ "/app/jetlend_react_lib/packages/jetlend-web-ui/src/ui/Skeleton/Skeleton.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/features/news/NewsCard/NewsCard.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/ui/Section/SectionSkeleton.tsx");
